import React from "react";
import { useLocation, useParams } from "react-router-dom";

import { useGameParamsContext } from "supercell-frontend-base/src/stores/gameParams";
import { useSnowplowContext } from "supercell-frontend-base/src/analytics/snowplow";
import { BoomBeachGameParams } from "../../validation/game-params";
import { getProps } from "./get-props";

import { ArticleView } from "./view";

type Params = { id: string; variant?: string; slug?: string };

export const ArticleController = () => {
    const { pathname: pagePath } = useLocation();
    const { gameParams } = useGameParamsContext<BoomBeachGameParams>();
    const { id, variant, slug } = useParams<Params>();
    const { trackPageView } = useSnowplowContext();

    const isolated =
        (variant && variant.toLowerCase() === "isolated") ||
        (slug && slug.toLowerCase() === "isolated");

    const track = (article: InboxArticle | undefined) => {
        trackPageView(article?.title ?? "", pagePath);
    };

    const props = {
        getProps: getProps(id!, !!isolated, gameParams as BoomBeachGameParams),
        id,
        track,
    };

    return <ArticleView {...props} />;
};
